import type {FormFieldSchema} from '../../../../../core/nutshell-fields/types';

import type {Field, FormFieldArrayRow, InputFormField} from '../../types';

import {VIEW_LABELS} from '../add-custom-field/consts';
import {isFormFieldInputRow} from '../add-custom-field/helpers';
import type {EditedFormFieldRef} from '../add-custom-field/types';
import type {CustomFieldView} from '../blocks-and-design/content-blocks/types';

export function editedFieldRowPathPrefix(ref: EditedFormFieldRef): string {
    return `pages.${ref.pageIndex}.fields.${ref.fieldIndex}`;
}

export function isFormPageInputField(
    row: FormFieldArrayRow | undefined
): row is InputFormField & {key: string} {
    return row != null && isFormFieldInputRow(row as Field);
}

export function editCustomFieldPanelTitle(view: CustomFieldView): string {
    return `Edit ${VIEW_LABELS[view]}`.toUpperCase();
}

export function getSingleChoiceFormFieldTypePresentation(
    field: Field,
    formSchema: FormFieldSchema
): 'radio' | 'dropdown' | null {
    if (!isFormFieldInputRow(field)) {
        return null;
    }
    const key = String(field.attributeId ?? field.fieldName ?? '');
    const prop = formSchema.properties[key];
    if (
        !prop ||
        !('isCustomField' in prop) ||
        !prop.isCustomField ||
        (prop.displayType !== 'radio' && prop.displayType !== 'dropdown')
    ) {
        return null;
    }
    if (field.type === 'RADIO') {
        return 'radio';
    }
    if (field.type === 'INPUT') {
        return 'dropdown';
    }
    return null;
}
